// convert API responses into View Models

// converting booleans to YES/NO, etc is more efficient once here than on every table render
// (for example typing a filter would re-render every value on every keystroke)

import { GroupsDataItem } from '../list/groups_list_types';
import apiUtil from '../../../core/utils/apiUtil';

export default function groupsListApiToVM(data: object): GroupsDataItem[] {
    const items = Array.isArray(data) ? (data as GroupsDataItem[]) : [];

    // do this once per API call rather than on every render
    items.forEach(item => {
        item.ObjectState = apiUtil.toUpperCase(item.ObjectState);
        item.Entities = apiUtil.arrayToJoinedString(item.Entities, ', ');
        item.Type = apiUtil.CEtoFacility(item.Type);
    });

    return items;
}
